<template>
	<section class="sub_container">
    <div class="search_form">
      <h2>공지사항</h2>
			<div class="contents">
				<div class="row">
					<div class="cell">
						<label>일자</label>
						<inputDate id="stDate" v-model="stDate" />
					</div>
          <div class="cell loc_edDate">
            <label for="" style="height:19px;"></label>
						<inputDate id="edDate" v-model="edDate" />
          </div>
				</div>
				<div class="row">
          <div class="cell">
            <div class="custom-select opt-color" style="background-color: transparent; border: 0px;">
              <select class="select" v-model="srchTypeCode">
								<option value="title">제목</option>
								<option value="writerName">작성자</option>
              </select>
            </div>
						<input type="text" class="input-text w100-p"
								@keyup.enter="searchBtn"
								v-model="srchKeyWord">
          </div>
          <div class="cell">
          </div>
				</div>
			</div>
    </div>
		<div class="sub_sh_btn_wrap">
			<button class="sh_btn" @click="searchBtn">조회</button>
		</div>
		<div class="sub_contents">
      <div class="sub_contents_wrap">
        <div class="board_list type03 tbl_box">
          <table class="board_table" style="table-layout:fixed; width:630px;">
            <caption class="hide">공지사항 테이블</caption>
            <colgroup>
              <col style="width:50px;">
              <col style="width:80px;">
              <col style="width:150px;">
              <col style="width:100px;">
              <col style="width:100px;">
              <col style="width:50px;">
              <col style="width:50px;">
              <col style="width:50px;">
            </colgroup>
						<thead>
							<th scope="col">번호</th>
							<th scope="col">분류</th>
							<th scope="col">제목</th>
							<th scope="col">작성자</th>
							<th scope="col">작성일</th>
							<th scope="col">첨부</th>
							<th scope="col">댓글</th>
							<th scope="col">조회</th>
						</thead>
						<tbody>
              <tr v-for="(data, index) in dataList" v-bind:key="index"
									:style="checkPriority(data.priority)">
								<td>{{data.priority == 0 ? '고정' : data.bulletinBoardNo}}</td>
								<td>{{data.bulletinBoardTypeName}}</td>
								<td class="tal" @click="showBoardContent(data.bulletinBoardNo)" >{{data.bulletinBoardTitle}}</td>
								<td>{{data.updateUserName}}</td>
								<td>{{data.writeDate}}</td>
								<td class="tac">
									<div style="height:25px; width:25px; margin-left: 6px;" v-html="renderHasAttFile(data.hasAttachedFile)"></div>
								</td>
								<td class="tar">{{data.commentCnt}}</td>
								<td class="tar">{{data.readingCount}}</td>
							</tr>
						</tbody>
          </table>
				</div>
      </div>
    </div>
	</section>
</template>

<script>
import Vue from 'vue'
import router from '@/router'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import InputDate from '@/components/InputDate'

export default {
	name: 'notice',
	components: { InputDate },
	data() {
		return {
      AppConfig,
      Utils,
			stDate: '',
			edDate: '',
			srchTypeCode: 'title',
			srchKeyWord: '',
			dataList: []
		}
	},
	methods: {
		showBoardContent(boardNo) {
			const vm = this;
			setTimeout(function() {
				vm.$router.push({
					name: 'Write',
					params: {
						refBulletinBoardNo: boardNo,
						isNew: false,
						isRead: true,
						fromPage: 'Notice'
					}
				});
			}, 10);
		},
    setRightCalendarStyle() {// 우측 카렌다 스타일 지정
      var month_calendar = $('.loc_edDate')[0].childNodes[2].childNodes[0].childNodes[0].childNodes[0].childNodes[2];
      var year_calendar = $('.loc_edDate')[0].childNodes[2].childNodes[0].childNodes[0].childNodes[0].childNodes[4];
      var decade_year_calendar = $('.loc_edDate')[0].childNodes[2].childNodes[0].childNodes[0].childNodes[0].childNodes[6];
      
			$(month_calendar).css('left', '-123px');
			$(year_calendar).css('left', '-123px');
			$(decade_year_calendar).css('left', '-123px');
		},
		searchBtn() {
			const searchUrl = '/board/list';
			const params = {
				stDate: this.stDate,
				edDate: this.edDate,
				srchTypeCode: this.srchTypeCode,
				srchKeyWord: this.srchKeyWord
			}

			Utils.showLoading('loading_grid_resultList');
			
			Vue.httpClient
				.post(searchUrl, params)
				.then(response => {
					if (response.data.result) {
						this.dataList = response.data.result.list;
					}
				})
				.finally(_ => {
					Utils.hideLoading('loading_grid_resultList');
				});
		},
		renderHasAttFile(value) {
			if (value) {
				return '<div class="o_ico" style="margin-top: 5px; height:25px;"></div>';
			} else {
				return '';
			}
		},
		checkPriority(value) {
			if (value == 0) {
				return {'background-color': 'rgba(255, 248, 220, 1) !important'};
			}
		}
	},
	computed: {
		
	},
	mounted() {
    this.$nextTick(function() {
			var $this = this;
      this.setRightCalendarStyle(); // 우측 카렌다 스타일 지정
      this.searchBtn(); // 조회
		});
		
	},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/notice/Notice.vue